<div class="rel-dialog">
  <header class="rel-header">
    <h2 class="rel-header-title">
      {{ enableChangeFailField ? 'Update Change Fail' : 'Add New Description' }}
    </h2>
  </header>

  <form class="rel-form">
    <div mat-dialog-content class="rel-content">
      @if (enableChangeFailField) {
        <mat-form-field appearance="outline" class="rel-field">
          <mat-label>Change Fail</mat-label>
          <mat-select [(ngModel)]="changeFail" name="changeFail">
            <mat-option [value]="true">Success</mat-option>
            <mat-option [value]="false">Failure</mat-option>
          </mat-select>
        </mat-form-field>
      }
      @if (!descriptionToUpdate) {
        <mat-form-field class="rel-field" appearance="outline">
          <mat-label>
            {{ enableChangeFailField ? 'Explain reason for updating Change Fail state' : 'Add Description' }}
          </mat-label>
          <textarea
            matInput
            [(ngModel)]="newDescription"
            name="description"
            rows="9"
            style="resize: vertical;"
            [readonly]="false"
          ></textarea>
        </mat-form-field>
      }
      @if (descriptionToUpdate) {
        <mat-form-field class="rel-field" appearance="outline">
          <mat-label>Update Description</mat-label>
          <textarea
            matInput
            [(ngModel)]="descriptionToUpdate.Description"
            name="description"
            rows="9"
            style="resize: vertical;"
            [readonly]="false"
          ></textarea>
        </mat-form-field>
      }
    </div>

    <div class="rel-footer">
      <button mat-button type="button" class="rel-btn-cancel" (click)="cancel()">Cancel</button>
      <span class="rel-footer-spacer"></span>
      @if (descriptionToUpdate) {
        <button mat-flat-button type="button" class="rel-btn-primary" (click)="updateDescription(descriptionToUpdate)">
          <mat-icon>save</mat-icon> Save
        </button>
      }
      @if (!enableChangeFailField && !descriptionToUpdate) {
        <button mat-flat-button type="button" class="rel-btn-primary" (click)="addDescription(newDescription)">
          <mat-icon>save</mat-icon> Save
        </button>
      }
      @if (enableChangeFailField) {
        <button mat-flat-button type="button" class="rel-btn-primary" (click)="updateChangeFail(changeFail, newDescription)">
          <mat-icon>save</mat-icon> Save
        </button>
      }
    </div>
  </form>
</div>
